<template lang="pug">
  header(:class="{ 'is-fixed': scrolled }")
    .container(:class="{'has-layer': toggled}")
      router-link.logo(:to="{path: '/'}")
      .btn-menu(v-on:click="toggleMenu()")
        font-awesome-icon(icon="bars")
      .nav(:class="{'show': toggled}")
        .btn-close(@click="toggleMenu()")
          font-awesome-icon(icon="times-circle")
        ul.rows
          li.nav-item(v-for="(item, key) in navs")
            router-link(:to="{path: key}", v-if="key !== 'onlinedonate'", v-on:click.native="onClick()") {{ item }}
            a.is-highlight(href="https://camtw.eoffering.org.tw/", v-if="key === 'onlinedonate'", target="_href")
              font-awesome-icon(icon="donate", v-if="key === 'onlinedonate'")
              |  {{ item }}
</template>

<script>
import Datas from '@/../static/json/menu.json'

export default {
  name: 'HeaderNav',
  data () {
    return {
      toggled: false,
      navs: Datas.navs,
      recruit: Datas.recruit,
      scrolled: false
    }
  },
  methods: {
    toggleMenu () {
      this.toggled = !this.toggled
    },
    onClick () {
      this.toggled = false
    },
    handleScroll () {
      this.scrolled = window.scrollY > 10
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="sass" scoped>
.container
  +fs($ta: right)
  &.has-layer
    &::before
      +pos($p: fixed, $t: 0, $r: 0, $b: 0)
      +size($w: 100vw, $h: 100vh)
      content: ''
      display: block
      background-color: rgba(#000, .5)
      z-index: 3

.logo
  +size($w: 100px, $h: 100px)
  +pos($p: absolute, $t: 0, $l: 0)
  background-image: url('/static/images/img-logo.png')
  background-size: contain
  display: inline-block
  background-repeat: no-repeat
  +rwd(tbl)
    +size($w: 60px, $h: 60px)

.nav
  display: inline-block
  width: calc(100% - 120px)
  max-width: 720px
  margin-top: 22px
  &-item
    +fs($ta: right)
    width: 0
    flex: 1 1 auto
    a
      +fs($fz: 20px, $c: $c-smoke, $fw: bolder, $lh: 20px)
      padding: 16px 16px 10px
      &:hover
        +fs($c: $c-primary)
      &.is-highlight
        +fs($c: $c-primary)
        border: 1px solid $c-primary
        border-radius: 2px
        &:hover
          +fs($c: $c-smoke)
  +rwd(tbl)
    +pos($p: fixed, $t: 0, $r: 0, $b: 0)
    +size($w: 220px, $h: 100vh)
    background-color: #fff
    margin-top: 0
    padding-top: 0
    display: none
    z-index: 4
    box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.2)
    &.show
      display: block
    .rows
      display: block
    &-item
      +fs($ta: center)
      +size($w: 100%)
      a
        padding: 20px

.btn-close
  +fs($fz: 32px, $c: #fff, $ta: center)
  display: none
  padding: 10px
  cursor: pointer
  background-color: $c-grey
  +rwd(tbl)
    display: block

.btn-menu
  +fs($fz: 24px, $c: $c-smoke)
  +pos($p: absolute, $t: 20px, $r: 20px)
  +size($w: 40px, $h: 40px)
  display: none
  z-index: 1
  cursor: pointer
  +rwd(tbl)
    display: block
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue